import { IAppState } from '../../redux';
import { ETopBetsErrorCode } from '../../redux/reducers';
import { selectTopBetsErrorCode } from './selectTopBetsErrorCode';

const SERVER_ERRORS: (ETopBetsErrorCode | null)[] = [ETopBetsErrorCode.badRequest, ETopBetsErrorCode.fatalError];

export function selectNeedBetLeadersReload(state: IAppState): boolean {
  const errorCode = selectTopBetsErrorCode(state);

  return SERVER_ERRORS.includes(errorCode);
}
